import { useEffect, useState } from 'react'

import { IconCircleFilled } from '@tabler/icons-react'

import Row from '../Row/Row'

const AssistantTyping = () => {
  const [animationStates, setAnimationStates] = useState([0, 0, 0])

  useEffect(() => {
    // Animation timing
    const intervalTime = 400 // ms between dot animations
    const animationCycle = 1200 // total animation cycle time

    // Start the animation loop
    const interval = setInterval(() => {
      setAnimationStates((prevState) => {
        const newState = [...prevState]

        // Update animation state for each dot
        for (let i = 0; i < 3; i++) {
          const offset = (i * intervalTime) / 3
          const time = (Date.now() + offset) % animationCycle
          // Create a value between 0 and 1 based on position in animation cycle
          newState[i] = Math.sin((time / animationCycle) * Math.PI) ** 2
        }

        return newState
      })
    }, 50)

    return () => clearInterval(interval)
  }, [])

  return (
    <Row
      gap={'0px'}
      sx={{ height: '28px' }}
    >
      {animationStates.map((state, index) => (
        <IconCircleFilled
          key={index}
          size={12}
          style={{
            opacity: 0.3 + state * 0.7,
            transform: `scale(${0.6 + state * 0.4})`,
            transition: 'all 0.2s ease-in-out',
          }}
        />
      ))}
    </Row>
  )
}

export default AssistantTyping
